import { useTranslation } from 'react-i18next'

import { getRequestOptions } from '../../../../../api'
import { useScreen } from '../../../../../hooks'
import { getItemsFromIdwellApiResponse } from '../../../../../utils/api'
import {
  RequestMultiSelect,
  RequestSelectFormikField,
  toRequestOptionSelectItems,
} from '../../../../Request'
import { getAsyncSelectShowSelectedApiParamIdPK } from '../../../../Select'
import { DOC_FLOW_FORM_FIELD_CONNECTED_REQUESTS } from '../../../DocFlow.constants'

function DocFlowFormConnectedRequestsField() {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen()

  return (
    <RequestSelectFormikField
      multi
      Select={RequestMultiSelect}
      controlProps={{
        borderless: !isMobileScreenSize,
        contentProps: {
          inputProps: {
            placeholder: t('DocFlow.FormConnectedRequestsFieldPlaceholderKey'),
          },
        },
      }}
      fieldComponentProps={{
        label: `${t('DocFlow.FormConnectedRequestsFieldLabelKey')}:`,
        shouldAdaptToMobileScreen: true,
      }}
      getData={getRequestOptions}
      getDataItems={getItemsFromIdwellApiResponse}
      getShowSelectedApiParam={getAsyncSelectShowSelectedApiParamIdPK}
      name={DOC_FLOW_FORM_FIELD_CONNECTED_REQUESTS}
      toPreparedItems={toRequestOptionSelectItems}
    />
  )
}

export default DocFlowFormConnectedRequestsField
